/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

const __vue_script__ = {
    name: 'ResetSessionCheckInDataModal',

    props: {
        eid: {
            type: String,
            required: true,
        },
        sessions: {
            type: Array,
            required: true,
        },
        onReset: {
            type: Function,
            required: true,
        },
    },

    created() {
        this.getSessions();
    },

    methods: {
        async onConfirm() {
            try {
                await this.$services.documents.resetSessionCheckIns(
                    this.eid, { sessionIds: this.sessions.map(d => d._id) },
                );
                this.onReset();
                this.$emit('close');
                this.$notify({
                    group: 'flashes',
                    title: this.$i18n.t('assisted_check_in.actions.reset_session_check_in_data_success').toString(),
                    type: 'success',
                    duration: 2000,
                });
            } catch (err) {
                console.error('[ResetSessionCheckInDataModal] could not reset', err);
                this.$notify({
                    group: 'flashes',
                    title: this.$i18n.t('general.error_occurred').toString(),
                    text: this.$i18n.t('general.try_later').toString(),
                    type: 'error',
                    duration: 5000,
                });
            }
        },
    },
};


/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "reset-session-check-in-data-modal modal-wrapper" },
    [
      _c("div", { staticClass: "modal-header" }, [
        _c("a", {
          staticClass: "close",
          attrs: { href: "#", "aria-label": _vm.$t("general.close") },
          on: {
            click: function ($event) {
              $event.preventDefault()
              return _vm.$emit("close")
            },
          },
        }),
        _c("h3", [
          _vm._v(
            _vm._s(
              _vm.$t(
                "assisted_check_in.actions.reset_session_check_in_data_plural"
              )
            )
          ),
        ]),
      ]),
      _c("div", { staticClass: "modal-body" }, [
        _c("p", [
          _vm._v(
            _vm._s(
              _vm.$t(
                "assisted_check_in.actions.reset_session_check_in_data_confirm"
              )
            )
          ),
        ]),
        _c(
          "ul",
          _vm._l(_vm.sessions, function (session) {
            return _c("li", [_vm._v(_vm._s(session.label))])
          }),
          0
        ),
        _c("p", { staticClass: "alert alert-warning" }, [
          _vm._v(
            _vm._s(
              _vm.$t(
                "assisted_check_in.actions.reset_session_check_in_data_warning"
              )
            )
          ),
        ]),
      ]),
      _c("div", { staticClass: "modal-footer" }, [
        _c(
          "footer",
          { staticClass: "actions", attrs: { slot: "bottom" }, slot: "bottom" },
          [
            _c(
              "button",
              {
                staticClass: "btn",
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    return _vm.$emit("close")
                  },
                },
              },
              [_vm._v(_vm._s(_vm.$t("general.cancel")))]
            ),
            _c(
              "button",
              {
                staticClass: "btn btn-danger",
                attrs: { type: "button" },
                on: { click: _vm.onConfirm },
              },
              [
                _vm._v(
                  _vm._s(
                    _vm.$t(
                      "assisted_check_in.actions.reset_session_check_in_data"
                    )
                  )
                ),
              ]
            ),
          ]
        ),
      ]),
    ]
  )
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "apps/backstage/src/ui/components/session-check-in/ResetSessionCheckInDataModal.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__